import { ReactNode } from 'react';
import { css } from '@emotion/react';
import { AnimatePresence, motion, MotionProps } from 'motion/react';
import { theme } from '@frontend/theme';

// note: don't add padding or margin here, it will
// mess with the animation.
const animatedContainer = css`
  display: flex;
  flex-direction: column;
  background-color: ${theme.colors.white};
  overflow: hidden;
`;

const spacingContainer = css`
  padding: ${theme.spacing(2, 3)};
`;

type FilterGroupProps = {
  active: boolean;
  remHeight: number;
  children: ReactNode;
} & MotionProps;

export const FilterGroup = ({ active, children, remHeight, ...rest }: FilterGroupProps) => {
  return (
    <AnimatePresence>
      {active && (
        <motion.div
          initial={{ maxHeight: '0rem', opacity: 0.5 }}
          animate={{ maxHeight: remHeight + 'rem', opacity: 1 }}
          exit={{ maxHeight: '0rem', opacity: 0.5 }}
          transition={{ mass: 1, tension: 200, friction: 26 }}
          css={animatedContainer}
          {...rest}
        >
          <div css={spacingContainer}>{children}</div>
        </motion.div>
      )}
    </AnimatePresence>
  );
};
